export default __webpack_public_path__ + "static/media/bg02.cd5be427.jpg";